"use client";

import { useEffect, useState } from "react";
import { Banner } from "@/types";
import { cn } from "@/lib/utils";

interface NoticeBarProps {
  banners: Banner[];
  className?: string;
}

export function NoticeBar({ banners, className }: NoticeBarProps) {
  const notices = banners.map((b) => b.title);

  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (notices.length <= 1) return;
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % notices.length);
        setVisible(true);
      }, 500);
    }, 5000);
    return () => clearInterval(interval);
  }, [notices.length]);

  return (
    <div
      className={cn(
        "bg-cream-dark border-b border-(--color-border) text-sm py-2.5",
        className,
      )}
    >
      <p
        className="text-center text-text-medium transition-opacity duration-500"
        style={{ opacity: visible ? 1 : 0 }}
      >
        {notices[index]}
      </p>
    </div>
  );
}
